import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getKeyDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES.id,
    requestParams: {
      messageVersion: rowInfo.original.messageVersion,
      eventId: rowInfo.original.eventId,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextWrapColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextWrapColumn('Error message', 'errorMessages'),
        new NavigationColumn(new NonZeroNumberColumn('Number of messages', 'numberOfMessages').withWidth(80), getKeyDetailsTabNavigationProps),
      ],
    },
  ];
};
